<template>
  <OwnCard
    :el="el"
    class="own-option w-full"
    :class="{
      'own-option--button': el === 'button',
      'own-option--selected': active,
    }"
    control
    :disabled="disabled ? 'disabled' : undefined"
    v-bind="el === 'button' && { type: 'button' }"
  >
    <slot />
  </OwnCard>
</template>

<script lang="ts" setup>
import { OwnCard } from '../OwnCard'

withDefaults(
  defineProps<{
    active?: boolean
    disabled?: boolean
    el?: string
  }>(),
  {
    active: false,
    disabled: false,
    el: 'button',
  }
)
</script>

<style lang="scss">
@use '@/styles/globals';

.own-option {
  padding: 12px 16px;

  transition: globals.transitionOne(background-color),
    globals.transitionOne(opacity);

  &--selected {
    background-color: var(--background-active);
  }

  &--button {
    &:hover {
      background-color: var(--background-active);
      opacity: 0.9;
      cursor: pointer;
      &:disabled {
        cursor: text;
        user-select: text;
      }
    }
  }
}
</style>
